import { ErrorBlock } from 'antd-mobile'
import { FC } from 'react'

// 暂无数据
const BlankBox: FC<{ name?: string }> = ({ name = '当前暂无数据' }) => {
  return <ErrorBlock status='empty' title='' description={name} />
}

export default BlankBox
